import React from 'react';
import './SortIcon.css';

export type SortDirection = 'asc' | 'desc' | null;

interface SortIconProps {
  /** Current sort direction for this column */
  direction: SortDirection;
  /** Whether this column is currently active for sorting */
  isActive?: boolean;
  /** Additional CSS classes */
  className?: string;
}

/**
 * Compact sort icon component for table headers
 * Shows up/down arrows with active state highlighting
 */
export const SortIcon: React.FC<SortIconProps> = ({ 
  direction, 
  isActive = false,
  className = '' 
}) => {
  // Single arrow that changes based on sort direction
  if (direction === 'asc') {
    return (
      <span className={`sort-icon ${className}`}>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 3L9 7H3L6 3Z" fill="#875cff" />
        </svg>
      </span>
    );
  }
  
  if (direction === 'desc') {
    return (
      <span className={`sort-icon ${className}`}>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 9L3 5H9L6 9Z" fill="#875cff" />
        </svg>
      </span>
    );
  }
  
  // No sort - show subtle double arrows
  return (
    <span className={`sort-icon sort-icon-inactive ${className}`}>
      <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 3L9 7H3L6 3Z" fill="currentColor" opacity="0.3" />
        <path d="M6 13L3 9H9L6 13Z" fill="currentColor" opacity="0.3" />
      </svg>
    </span>
  );
};

export default SortIcon;
